<template>
    <div>
        <div
            class="leo-row leo-hidden tablet:leo-flex leo-w-screen leo-shadow-4"
            v-if="isDesktopChannel"
        >
            <div
                class="leo-col leo-px-7xl leo-py-xl leo-bg-white leo-flex"
                style="height: 74px; align-items: center"
            >
                <img src="./../../../assets/images/logo.svg" alt="" />
            </div>
        </div>
        <div
            class="leo-row leo-hidden tablet:leo-flex leo-w-screen"
            v-if="!isDesktopChannel"
        >
            <div class="leo-col leo-px-3xl">
                <header class="leo-mt-3xl">
                    <div data-type="master-logo" class="leo-logo">
                        <img src="./../../../assets/images/3-1.svg" alt="" />
                    </div>
                </header>
            </div>
        </div>
    </div>
</template>
<script>
import { CommonClass } from "@/mixins"
export default {
    name: "TheHeader",
    components: {},
    mixins: [CommonClass],
    computed: {
        isDesktopChannel() {
            return this.$__checkIsDesktopChannel()
        },
    },
    data() {
        return {
            isShow: false,
        }
    },
}
</script>
